import { makeObservable, observable, flow, action } from "mobx";
import { api } from "@/lib/services";

import AddSubscriberSchema from "@/areas/subscriptions/schemas/AddSubscriberSchema";
import {
  beginSubscriberToast,
  completeSubscriberToast,
  failSubscriberToast,
} from "@/areas/subscriptions/components/subscribers/subscriberToast";

export default class ConfigureSubscriberStore {
  visible = false;
  processing = false;
  subscriber = null;
  options = null;

  constructor(parentStore, apiPrefix) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      subscriber: observable,
      options: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
    });

    this.parentStore = parentStore;
    this.apiPrefix = apiPrefix;
  }

  show(subscriber, options) {
    this.visible = true;
    this.subscriber = subscriber;
    this.options = options;
  }

  hide() {
    this.visible = false;
    this.subscriber = null;
    this.options = null;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
    if (!this.visible) {
      this.subscriber = null;
      this.options = null;
    }
  }

  *save(data) {
    let toastId;
    try {
      this.processing = true;
      const parseResult = AddSubscriberSchema.safeParse(data);
      if (!parseResult.success) {
        return parseResult;
      }

      toastId = beginSubscriberToast({
        user: data.user,
        roles: data.subscriptions,
        message: "Adding as",
      });

      const response = yield api.post(`${this.apiPrefix}/subscribers`, data);
      this.visible = false;

      completeSubscriberToast({
        toastId,
        user: data.user,
        roles: data.subscriptions,
        message: "Added as",
      });

      this.parentStore.browseSubscribersStore.load({ search: "", page: 1 });
      return { success: true, data: response.data, options: this.options };
    } catch (e) {
      failSubscriberToast({
        toastId,
        message: "Error while adding subscriber",
        description: e.message,
      });
      return { success: false, error: e, options: this.options };
    } finally {
      this.processing = false;
    }
  }
}
